import * as React from "react"

import { cn } from "~/utils/helpers"

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { isTv?: boolean }
>(({ className, isTv, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-[12px] bg-base text-fg-base shadow-card-rest overflow-hidden",
      isTv && "bg-zinc-900 border border-zinc-800 shadow-none",
      className,
    )}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { isTv?: boolean }
>(({ className, isTv, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex flex-row justify-between items-center gap-1 py-3 px-4 h-11 bg-component border-b border-base",
      isTv && "py-4 px-6 h-auto border-zinc-800",
      className,
    )}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement> & { large?: boolean; isTv?: boolean }
>(({ className, large, isTv, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(large ? "heading-xs" : "label-base", isTv && "text-xl text-zinc-300", className)}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardEmptyTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3 ref={ref} className={cn("paragraph-base text-fg-subtle", className)} {...props} />
))
CardEmptyTitle.displayName = "CardEmptyTitle"

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("paragraph-sm text-fg-subtle", className)} {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { isTv?: boolean }
>(({ className, isTv, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-4 py-3 bg-base", isTv && "px-6 py-4 bg-zinc-900", className)}
    {...props}
  />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-row justify-between items-center gap-1 px-4 py-3 border-t border-base bg-base paragraph-base",
        className,
      )}
      {...props}
    />
  ),
)
CardFooter.displayName = "CardFooter"

export { Card, CardContent, CardDescription, CardEmptyTitle, CardFooter, CardHeader, CardTitle }
